import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=c8f6daf0&scoped=true"
import script from "./CmsContent.vue?vue&type=script&lang=ts"
export * from "./CmsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f6daf0",
  null
  
)

export default component.exports